(ns minorodata.global-search.subs
  (:require [re-frame.core :as re-frame]))


(re-frame/reg-sub
 :global-search/results
 (fn [db _]
   (:global-search/results db)))


(re-frame/reg-sub
 :global-search/pagination
 (fn [db _]
   (:global-search/pagination db)))


(re-frame/reg-sub
 :global-search/sort
 (fn [db _]
   (:global-search/sort db)))


(re-frame/reg-sub
 :global-search/recent
 (fn [db _]
   (:global-search/recent db)))
